import type { PaymentDetail } from '@/modules/payments/services/payments.service';
import type { PortalOverview } from '@/modules/portal/types/portalOverview';
import { portalDaysBadgeKey } from '@/modules/portal/utils/portalOverviewHelpers';

export function formatPortalPaymentDate(payment: PaymentDetail, locale: string): string {
  const iso = payment.processedAt ?? payment.createdAt;
  return new Date(iso).toLocaleString(locale, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function formatPortalProviderReference(payment: PaymentDetail): string | null {
  return payment.providerPaymentId ?? payment.paymentIntentId ?? null;
}

export function formatPortalPaymentMethod(
  payment: PaymentDetail,
  formatProvider: (provider: string) => string,
): string | null {
  if (payment.paymentMethodType && payment.paymentMethodLast4) {
    return `${payment.paymentMethodType} •••• ${payment.paymentMethodLast4}`;
  }
  if (payment.paymentMethodType) {
    return payment.paymentMethodType;
  }
  if (payment.provider) {
    return formatProvider(payment.provider);
  }
  return null;
}

export function resolvePortalPaymentContext(
  payment: PaymentDetail,
  overview: PortalOverview | undefined,
): { productName: string | null; planName: string | null } {
  if (overview?.subscription_id && payment.subscriptionId === overview.subscription_id) {
    return {
      productName: overview.product_name,
      planName: overview.plan_name,
    };
  }
  return { productName: null, planName: null };
}

export function portalPaymentsShowRenewCta(
  paymentsEmpty: boolean,
  overview: PortalOverview | undefined,
): boolean {
  if (paymentsEmpty) return true;
  if (!overview) return false;
  if (portalDaysBadgeKey(overview) === 'expired') return true;
  return overview.subscription_status === 'expired' || overview.subscription_status === 'cancelled';
}

export function canDownloadPortalReceipt(payment: PaymentDetail): boolean {
  return payment.status === 'succeeded';
}
